import React, { useEffect, useState } from "react";
import { gridColumnsTrustLedsgerReserve } from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import { SpinnerBlock } from "../../Utils/CustomComponent";

import urls from "../../Utils/urls";
import axios from "../../axios";
import { useAbortController } from "../../hooks/useAbortController";
import { loadingTypes } from "../../Utils/constant";

const TrustLedgerReserveTable = ({
  tHeight = "30vh",
  className,
  loanId,
  viewAllModal = true,
}) => {
  const [trustLedgerReserve, setTrustLedgerReserve] = useState([]);
  const [reserveLoading, setReserveLoading] = useState(loadingTypes.loading);
  const { signal } = useAbortController();

  useEffect(() => {
    setTrustLedgerReserve(null);
    const fetchData = async () => {
      const res = await axios.get(urls.borrower.getTrustLedgerReserve(loanId), {
        signal,
      });
      let data = res?.data?.[0] || [];
      setTrustLedgerReserve(data);
      setReserveLoading(loadingTypes.fulfilled);
    };
    fetchData();
  }, [loanId]);

  return (
    <>
      {/* {trustLedgerReserve ? ( */}
      <CommonGrid
        className={`col-sm-12 ${className}`}
        title={"Trust Ledger Reserve"}
        gridColumns={gridColumnsTrustLedsgerReserve}
        columnData={trustLedgerReserve}
        tableTotal={["Payment"]}
        status={reserveLoading}
        viewAllModal={viewAllModal}
        // tHeight={tHeight}
      />
      {/* ) : (
        <SpinnerBlock />
      )} */}
    </>
  );
};

export default TrustLedgerReserveTable;
